<template>
  <div class="justify-center layout mt-n1">
    <v-btn color="success" small @click="updatePBXRow" style="width: 100px;">
      Edit
    </v-btn>
    <v-btn
      v-if="params.data.hasLogin"
      color="secondary"
      small
      @click="viewAs"
      style="width: 100px;"
    >
      View As
    </v-btn>
    <v-btn
      color="success"
      small
      @click="setDealer"
      v-show="!params.data.hasLogin"
      style="width: 100px;"
    >
      Create Login
    </v-btn>

    <v-btn
      color="red white--text"
      small
      @click="onDisable"
      style="width: 100px;"
      :disabled="hosted_pbx.length == 0"
    >
      Disable
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue';
import { ref } from 'vue';
import { createNamespacedHelpers, mapActions } from 'vuex';
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(
  `orders/featureFlag`
);
export default Vue.extend({
  data: () => ({
    hosted_pbx: '',
  }),

  methods: {
    updatePBXRow() {
      this.params.updatePBXRow(this.params.data);
    },
    viewAs() {
      this.params.onViewAs(this.params.data);
    },
    setDealer() {
      this.params.onEdit(this.params.data);
    },
    onDisable() {
      this.params.onDisable(this.params.data);
    },
  },
  mounted() {
    this.hosted_pbx = this.params.data.hostedPbxDomain;
  },
});
</script>
